var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _rect3, _rect4, _rect5, _rect6, _ellipse, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9889 62.5319L37.6044 62.7778L39.7265 62.5319L44.096 61.0567L48.4657 59.2128L54.3346 54.7872L59.955 47.9031L60.9545 46.0591L62.5793 41.8794L64.0791 37.8227L64.0818 32.4137L63.5863 24.792L59.9696 18.3995L54.8551 11.8842L48.616 7.82742L44.1232 6.10638L33.389 5L22.403 8.31915L14.2866 14.0969L9.04066 20.9811L5.91687 27.4965L5.41478 33.1513L5.90999 41.3877L10.8977 51.8369L16.2621 57.8605L24.4986 61.5485L30.9889 62.5319Z",
    fill: "#F1E9DA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.42484,
    y: 37.0894,
    width: 65.1503,
    height: 18.0556,
    rx: 1.27451,
    fill: "white",
    stroke: "#F1E9DA",
    strokeWidth: 0.849673
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.42484,
    y: 15.6348,
    width: 65.1503,
    height: 18.0556,
    rx: 1.27451,
    fill: "white",
    stroke: "#F1E9DA",
    strokeWidth: 0.849673
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7011 24.1089C13.7011 26.515 11.7177 28.4826 9.24997 28.4826C6.78222 28.4826 4.79888 26.515 4.79888 24.1089C4.79888 21.7027 6.78222 19.7352 9.24997 19.7352C11.7177 19.7352 13.7011 21.7027 13.7011 24.1089Z",
    stroke: "#F1E9DA",
    strokeWidth: 1.31211
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98068 22.5233V26.2432H8.79978V23.8814L8.44551 24.1175L7.9141 23.2319L8.97691 22.5233H9.98068Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7011 45.7759C13.7011 48.182 11.7177 50.1496 9.24997 50.1496C6.78222 50.1496 4.79888 48.182 4.79888 45.7759C4.79888 43.3697 6.78222 41.4021 9.24997 41.4021C11.7177 41.4021 13.7011 43.3697 13.7011 45.7759Z",
    stroke: "#F1E9DA",
    strokeWidth: 1.31211
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9254 46.7878V47.9097H8.15028V47.1421L9.3607 45.8726C9.41581 45.8214 9.46502 45.7703 9.50832 45.7191C9.54374 45.6758 9.5772 45.6286 9.60869 45.5774C9.64018 45.5223 9.65593 45.4731 9.65593 45.4298C9.65593 45.3707 9.63625 45.3274 9.59688 45.2999C9.55752 45.2684 9.50832 45.2526 9.44927 45.2526C9.39023 45.2526 9.33512 45.2802 9.28395 45.3353C9.23671 45.3865 9.21309 45.4573 9.21309 45.5479L8.06171 45.4298C8.06958 45.2448 8.10895 45.0735 8.1798 44.9161C8.25066 44.7586 8.34906 44.6228 8.47503 44.5087C8.60099 44.3906 8.75057 44.2981 8.92377 44.2312C9.10091 44.1642 9.29575 44.1308 9.50832 44.1308C9.72875 44.1308 9.92557 44.1623 10.0988 44.2253C10.2759 44.2882 10.4255 44.3729 10.5475 44.4791C10.6695 44.5854 10.762 44.7114 10.825 44.857C10.8919 44.9987 10.9254 45.1503 10.9254 45.3117C10.9254 45.477 10.89 45.6305 10.8191 45.7722C10.7483 45.9139 10.6695 46.0379 10.5829 46.1442C10.4806 46.2702 10.3684 46.3863 10.2464 46.4926L9.95115 46.7878H10.9254Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7141,
    y: 39.9717,
    width: 29.8571,
    height: 4.64286,
    rx: 1.69935,
    fill: "#EAEAEA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7141,
    y: 19.0791,
    width: 20.4286,
    height: 3.86905,
    rx: 1.69935,
    fill: "#EAEAEA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7141,
    y: 46.1626,
    width: 44.7857,
    height: 5.41667,
    rx: 1.69935,
    fill: "#EAEAEA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7141,
    y: 24.4961,
    width: 34.5714,
    height: 5.41667,
    rx: 1.69935,
    fill: "#EAEAEA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.3573,
    cy: 24.4955,
    rx: 3.92857,
    ry: 3.86905,
    fill: "#B8BE13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1132 24.2278C56.0358 24.1504 56.0121 24.0687 56.0422 23.9827C56.0723 23.8925 56.1325 23.8323 56.2228 23.8022C56.3174 23.7721 56.4012 23.7936 56.4743 23.8667L57.8413 25.2273L60.2401 22.8349C60.3175 22.7575 60.3992 22.7339 60.4852 22.764C60.5755 22.7941 60.6356 22.8564 60.6657 22.951C60.6958 23.0413 60.6743 23.1229 60.6012 23.196L58.0283 25.7754C57.9724 25.8313 57.9101 25.8592 57.8413 25.8592C57.7725 25.8592 57.7102 25.8313 57.6543 25.7754L56.1132 24.2278Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.4905975d.svg";
export { ForwardRef as ReactComponent };